function round2(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}

/**
 * Business rounding policy for session billing hours.
 *
 * Requested examples covered:
 * - 45/50/55 min -> 1.0h
 * - 65/70 min -> 1.0h
 * - around 1h20m -> 1.5h
 * - 1h15m, 1h45m, 1h55m -> 2.0h
 */
export function calculateBusinessRoundedHoursFromMinutes(rawMinutes) {
  const minutes = Math.ceil(Number(rawMinutes) || 0);
  if (!Number.isFinite(minutes) || minutes <= 0) return 0;

  // Guard for short/aborted sessions.
  if (minutes <= 30) return 0.5;

  // 45/50/55 and 65/70 should stay at 1 hour.
  if (minutes <= 70) return 1;

  // Explicit business rule: 1h15 counts as 2h.
  if (minutes === 75) return 2;

  // Around 1h20 should be 1.5h.
  if (minutes <= 85) return 1.5;

  // Most standard long sessions (including 1h45, 1h55) count as 2h.
  if (minutes <= 120) return 2;

  // For unusually long sessions, continue in 0.5h steps with a small grace window.
  const adjustedMinutes = Math.max(0, minutes - 10);
  const halfHourBlocks = Math.ceil(adjustedMinutes / 30);
  return round2(halfHourBlocks * 0.5);
}

